import { MealCreditInfoTextProps } from './constructMealCreditInfoText.utils';

export function areAllWeekdaysSelected(
  props: Pick<MealCreditInfoTextProps, 'selectedDays'>
): boolean {
  const { selectedDays } = props;
  return selectedDays.filter((selected) => selected).length === 7;
}
